import { combineReducers } from '@reduxjs/toolkit';

import submissions from './stores/submissions';
import orders from './stores/orders';
import products from './stores/products';

const rootReducer = combineReducers({
  submissions,
  orders,
  products,
});

export default rootReducer;
